var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper flex-col-center-center"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"qrcode"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex-center-center"},[_c('img',{attrs:{"src":"https://s1.ax1x.com/2020/04/14/Gxf32F.jpg","alt":"","srcset":""}})])
}]

export { render, staticRenderFns }